module.exports = __webpack_public_path__ + "public/images/writing-background-pattern.0edf8ccff5bcda11484cff56fccae080.svg";